import { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useLogin, requireLogin, checkLoggedIn, loginRequest, getRedirectUri } from "./authConfig";
import { LoginContext } from "./loginContext";
import Layout from "./pages/layout/Layout";

const LayoutWrapper = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    if (useLogin) {
        const { instance, inProgress } = useMsal();
        // Keep track of the mounted state to avoid setting state in an unmounted component
        const mounted = useRef<boolean>(true);
        useEffect(() => {
            // Wait until MSAL has finished processing any in-progress interaction
            // (redirect response, token acquisition, etc.) before checking login state.
            // Without this guard, loginRedirect fires before MSAL can process the
            // returning redirect, causing an infinite redirect loop.
            if (inProgress !== InteractionStatus.None) return;

            // Clean up /redirect from the URL after MSAL has processed the response
            if (window.location.pathname === "/redirect") {
                window.history.replaceState({}, "", "/");
            }

            mounted.current = true;
            checkLoggedIn(instance)
                .then(isLoggedIn => {
                    if (mounted.current) {
                        setLoggedIn(isLoggedIn);
                        if (!isLoggedIn && requireLogin) {
                            instance
                                .loginRedirect({
                                    ...loginRequest,
                                    redirectUri: getRedirectUri()
                                })
                                .catch(e => console.error("loginRedirect failed", e));
                        }
                    }
                })
                .catch(e => {
                    console.error("checkLoggedIn failed", e);
                });
            return () => {
                mounted.current = false;
            };
        }, [instance, inProgress]);

        // Render nothing while MSAL is busy or redirect is in progress
        if (requireLogin && !loggedIn) {
            return null;
        }

        return (
            <LoginContext.Provider value={{ loggedIn, setLoggedIn }}>
                <Layout />
            </LoginContext.Provider>
        );
    } else {
        return (
            <LoginContext.Provider
                value={{
                    loggedIn,
                    setLoggedIn
                }}
            >
                <Layout />
            </LoginContext.Provider>
        );
    }
};

export default LayoutWrapper;
